import {AsyncPipe, LowerCasePipe} from '@angular/common';
import {Component, EventEmitter, Input, Output} from '@angular/core';
import {OtpVerificationModule} from '@aztrix/components/otp-verification';
import {TranslatePipe} from '@aztrix/translate';

import {ModeService} from '../../../services/mode.service';
import {VerificationService} from '../../../services/verification.service';

@Component({
  selector: 'ax-verification-step',
  templateUrl: './verification-step.component.html',
  styleUrls: ['./verification-step.component.scss', '../../form.scss'],
  standalone: true,
  imports: [OtpVerificationModule, AsyncPipe, LowerCasePipe, TranslatePipe],
})
export class VerificationStepComponent {
  @Input() verificationValue: string;
  @Output() completed = new EventEmitter<any>();

  mode$ = this._modeService.mode$;

  constructor(
    public verification: VerificationService,
    private _modeService: ModeService
  ) {}
}
